import { Component, Input } from '@angular/core';
import { TdCollapseAnimation } from './../../common/animations/collapse/collapse.animation';
import { StepState } from './../../steps/step.component';
export class TdStepBodyComponent {
/**
 * active?: boolean
 * Sets for active/inactive states on body.
 */
active: boolean;
/**
 * state?: StepState or ['none' | 'required' | 'complete']
 * Sets styles for state of body.
 * Defaults to [StepState.None | 'none'].
 */
state: StepState = StepState.None;
/**
 * Returns 'true' if [state] equals to [StepState.Complete | 'complete'], else 'false'.
 * @return {?}
 */
isComplete(): boolean {
        return this.state === StepState.Complete;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    moduleId: module.id,
    selector: 'td-step-body',
    styleUrls: ['./step-body.component.css'],
    templateUrl: './step-body.component.html',
    animations: [
        TdCollapseAnimation()
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'active': [{ type: Input, args: ['active', ] },],
'state': [{ type: Input, args: ['state', ] },],
};
}

function TdStepBodyComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdStepBodyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepBodyComponent.ctorParameters;
/** @type {?} */
TdStepBodyComponent.propDecorators;
/**
 * active?: boolean
 * Sets for active/inactive states on body.
 * @type {?}
 */
TdStepBodyComponent.prototype.active;
/**
 * state?: StepState or ['none' | 'required' | 'complete']
 * Sets styles for state of body.
 * Defaults to [StepState.None | 'none'].
 * @type {?}
 */
TdStepBodyComponent.prototype.state;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
